import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORT_DEVICE_MOUNTS].GET_REPORT_DEVICE_MOUNTS]: {
		url: '/company/:companyId/device_mounts/',
	},
	[ModulesConfigMap[ModulesMap.REPORT_DEVICE_MOUNTS].GET_REPORT_DEVICE_MOUNT]: {
		url: '/company/:companyId/device_mounts/:deviceMountId/',
	},
}
